import React from 'react'
import { useTranslation } from 'react-i18next'
import { useDroppable } from '@dnd-kit/core'

import TasksBoardCard from 'pages/parts/tasks/TasksBoardCard'

function TasksBoardColumn({
	column,
	movingIds,
	canManageTask,
	canEditTask = null,
	onCreate = null,
	onLoadMore = null,
	onOpenDetail = null,
	onEdit = null,
	onDelete = null,
}) {
	const { t } = useTranslation()

	const { isOver, setNodeRef } = useDroppable({
		id: 'column-' + column.id,
		data: { statusId: column.id },
	})

	function handleScroll(e) {
		const element = e.currentTarget
		if (element.scrollHeight - element.scrollTop - element.clientHeight < 120) {
			if (typeof onLoadMore === 'function') onLoadMore(column)
		}
	}

	return (
		<div className="tasks-board-column">
			<div className="tasks-column-header" style={{ borderTopColor: column.color || '#5b73e8' }}>
				<span className="tasks-column-dot" style={{ background: column.color || '#5b73e8' }}></span>
				<span className="tasks-column-title" title={column.name}>{column.name}</span>
				<span className="tasks-column-count"
					style={{ background: (column.color || '#5b73e8') + '1f', color: column.color || '#5b73e8' }}>
					{column.total || 0}
				</span>
				<button type="button" className="tasks-column-add" title={t('task_create')}
					onClick={() => { if (typeof onCreate === 'function') onCreate(column) }}>
					<i className="uil uil-plus"></i>
				</button>
			</div>

			<div ref={setNodeRef}
				className={'tasks-column-body' + (isOver ? ' is-over' : '')}
				onScroll={handleScroll}>

				{column.data?.map((item) => (
					<TasksBoardCard key={item.id}
						task={item}
						column={column}
						isMoving={movingIds.has(item.id)}
						canManage={canManageTask(item)}
						canEdit={(canEditTask || canManageTask)(item)}
						onOpenDetail={onOpenDetail}
						onEdit={onEdit}
						onDelete={onDelete}>
					</TasksBoardCard>
				))}

				{(!column.data || column.data.length === 0) && !column.loading &&
					<div className="tasks-column-empty">{t('task_no_more_data')}</div>
				}

				{column.loading &&
					<div className="tasks-column-loader">{t('loading')}...</div>
				}
			</div>
		</div>
	)
}

export default TasksBoardColumn
